module.exports = __webpack_public_path__ + "img/vip-coupon-ratio.606cd7f1.png";